import { Plane, Lightbulb, Compass, Globe2 } from "lucide-react";
import { slug } from "@/lib/geo";

const Card = ({ icon: Icon, title, hint, items, color, testId }) => (
  <div className="rounded-2xl border border-white/[0.07] bg-[#131A26] p-5" data-testid={testId}>
    <div className="flex items-center gap-2" style={{ color }}><Icon size={16} /><p className="font-display font-semibold">{title}</p></div>
    <p className="text-xs text-slate-500 mt-1">{hint}</p>
    <div className="flex flex-wrap gap-1.5 mt-4">
      {items.length === 0 && <span className="text-xs text-slate-600">Nothing yet</span>}
      {items.map((c) => (
        <span key={c} className="px-2.5 py-1 rounded-full text-xs" style={{ background: `${color}1f`, color }} data-testid={`${testId}-${slug(c)}`}>{c}</span>
      ))}
    </div>
  </div>
);

export const Overlap = ({ me, friend, name }) => {
  const set = (list) => new Set(list.map((x) => x.country));
  const myBeen = set(me.visited);
  const theirWish = set(friend.wishlist);
  const theirBeen = set(friend.visited);
  const both = me.wishlist.map((w) => w.country).filter((c) => theirWish.has(c));
  const askThem = me.wishlist.map((w) => w.country).filter((c) => theirBeen.has(c));
  const guideThem = friend.wishlist.map((w) => w.country).filter((c) => myBeen.has(c));
  const bothBeen = [...myBeen].filter((c) => theirBeen.has(c));

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4" data-testid="overlap-panel">
      <Card icon={Plane} color="#F59E0B" title="Go together" hint={`On both your bucketlists`} items={both} testId="overlap-both-want" />
      <Card icon={Lightbulb} color="#7DD3FC" title={`Ask ${name} for tips`} hint={`You want to go, ${name} has been`} items={askThem} testId="overlap-ask-them" />
      <Card icon={Compass} color="#34D399" title={`Show ${name} around`} hint={`${name} wants to go, you've been`} items={guideThem} testId="overlap-guide-them" />
      <Card icon={Globe2} color="#FB7185" title="Both been" hint="Countries you've both explored" items={bothBeen} testId="overlap-both-been" />
    </div>
  );
};
